import styled from 'styled-components';

export const BGWrap = styled.div`
  width: 100%;
  padding-top: ${({ width, height }) => `${(height / width) * 100}%`};
  border-top: none;
  border-bottom: none;
  box-sizing: border-box;
  background: url(${({ imgUrl }) => imgUrl}) center center no-repeat;
  background-size: cover;
  position: relative;
`;

export const YoutubeWrap = styled.div`
  position: absolute;
  width: 96.05%;
  height: 33.51%;
  top: 64.72%;
  left: 2.2%;

  > div {
    width: 100%;
    height: 100%;
  }

  iframe {
    width: 100%;
    height: 100%;
  }
`;

export const ButtonBGWrap = styled.div`
  width: 100%;
  padding-top: 26.61%;
  background-color: #FCFCFC;
  box-sizing: border-box;
  position: relative;
`;

export const ButtonWrap = styled.div`
  width: 83.09%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

export const Button = styled.div`
  width: 100%;
  margin: 0 auto;
  padding-top: ${({ width, height }) => `${(height / width) * 100}%`};
  box-sizing: border-box;
  background: url(${({ imgUrl }) => imgUrl}) center center no-repeat;
  background-size: cover;
  position: relative;
`;

export const CodeBGWrap = styled.div`
  width: 100%;
  margin: 0 auto;
  padding-top: 121.4%;
  box-sizing: border-box;
  background: url(${({ imgUrl }) => imgUrl}) center center no-repeat;
  background-size: cover;
  position: relative;
`;
